import { Scene } from "../scene.js";
import { Mesh } from "./mesh.js";
import { SimplificationQueue, SimplificationType } from "./meshSimplification.js";
import { SceneComponentConstants } from "../sceneComponent.js";
Object.defineProperty(Scene.prototype, "simplificationQueue", {
    get: function () {
        if (!this._simplificationQueue) {
            this._simplificationQueue = new SimplificationQueue();
            var component = this._getComponent(SceneComponentConstants.NAME_SIMPLIFICATIONQUEUE);
            if (!component) {
                component = new SimplicationQueueSceneComponent(this);
                this._addComponent(component);
            }
        }
        return this._simplificationQueue;
    },
    set: function (value) {
        this._simplificationQueue = value;
    },
    enumerable: true,
    configurable: true,
});
Mesh.prototype.simplify = function (settings, parallelProcessing, simplificationType, successCallback) {
    if (parallelProcessing === void 0) { parallelProcessing = true; }
    if (simplificationType === void 0) { simplificationType = SimplificationType.QUADRATIC; }
    this.getScene().simplificationQueue.addTask({
        settings: settings,
        parallelProcessing: parallelProcessing,
        mesh: this,
        simplificationType: simplificationType,
        successCallback: successCallback,
    });
    return this;
};
/**
 * Defines the simplification queue scene component responsible to help scheduling the various simplification task
 * created in a scene
 */
var SimplicationQueueSceneComponent = /** @class */ (function () {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */
    function SimplicationQueueSceneComponent(scene) {
        /**
         * The component name helpfull to identify the component in the list of scene components.
         */
        this.name = SceneComponentConstants.NAME_SIMPLIFICATIONQUEUE;
        this.scene = scene;
    }
    /**
     * Registers the component in a given scene
     */
    SimplicationQueueSceneComponent.prototype.register = function () {
        this.scene._beforeCameraUpdateStage.registerStep(SceneComponentConstants.STEP_BEFORECAMERAUPDATE_SIMPLIFICATIONQUEUE, this, this._beforeCameraUpdate);
    };
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */
    SimplicationQueueSceneComponent.prototype.rebuild = function () {
        // Nothing to do for this component
    };
    /**
     * Disposes the component and the associated resources
     */
    SimplicationQueueSceneComponent.prototype.dispose = function () {
        // Nothing to do for this component
    };
    SimplicationQueueSceneComponent.prototype._beforeCameraUpdate = function () {
        if (this.scene._simplificationQueue && !this.scene._simplificationQueue.running) {
            this.scene._simplificationQueue.executeNext();
        }
    };
    return SimplicationQueueSceneComponent;
}());
export { SimplicationQueueSceneComponent };
//# sourceMappingURL=meshSimplificationSceneComponent.js.map